'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { CatInputField } from '@blocks-react/components/InputField';
import { useFormContext } from 'react-hook-form';
import { useInputController } from './../../../hooks/form-controllers/useInputController/useInputController';
export const MyEquipmentNickname = (props) => {
    const { name, rules = {}, isError, placeholder, fieldNote, onChange: onInputChange } = props;
    const { setValue, getValues } = useFormContext();
    const { inputField, field } = useInputController({ name, rules });
    const { isError: fieldError, fieldNote: fieldErrorMessage } = inputField;
    const error = !!(isError ?? fieldError);
    const note = fieldNote ?? fieldErrorMessage;
    const nickName = getValues(name);
    const onBlChange = (e) => {
        const inputValue = e.detail.value;
        if (nickName !== inputValue) {
            if (onInputChange) {
                onInputChange(inputValue);
            }
            setValue(name, inputValue);
            field.onChange(e);
        }
    };
    return (
    /* TODO - Input Validation - Ensure that <,>,/,\ characters and <script> tags are not allowed to type/paste. */
    // TODO - Input Validation - Ensure that maximum query params length is 1024 characters
    _jsx(CatInputField, { ...inputField, hideLabel: true, type: "text", placeholder: placeholder, "data-testid": props.name, value: nickName, fieldNote: note, status: error ? 'error' : undefined, name: name, onBlChange: onBlChange }));
};
